import { motion } from "motion/react";

const SQUARE_SIZE = 20;

export function BackgroundDots() {
	return (
		<div className="-z-10 absolute inset-0 pointer-events-none dark:hidden">
			<svg
				className="w-screen h-screen"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>Dotted background</title>
				<defs>
					<pattern
						id="dots-pattern"
						width={SQUARE_SIZE}
						height={SQUARE_SIZE}
						patternUnits="userSpaceOnUse"
						transform="translateX(25%)"
					>
						<circle
							cx="1"
							cy="1"
							r="1"
							className="fill-primaryGray-200 dark:fill-primaryGray-800/60"
						/>
					</pattern>
				</defs>
				<motion.rect
					width="100%"
					height="calc(100% + 30px)"
					fill="url(#dots-pattern)"
					initial={{ y: -SQUARE_SIZE }}
					animate={{ y: 0 }}
					transition={{
						duration: 5.5,
						ease: "linear",
						repeat: Number.POSITIVE_INFINITY,
						repeatType: "loop",
						repeatDelay: 0,
					}}
				/>
			</svg>
		</div>
	);
}
